export const FIRM_DOCUMENT_FOLDER_DELETE_DIALOG_TEST_IDS = {
  confirmButton: 'firm-documents-folder-delete-confirm-button',
  dialog: 'firm-documents-folder-delete-dialog',
} as const;
